import React from "react";
import { Label } from "../fields/Fields";

export type RadioButtonGroupProps = {
  children: React.ReactNode;
  className?: string;
  color?: "blue" | "green" | "red" | "yellow" | "indigo";
  size?: "sm" | "md" | "lg";
  value?: { value: any; setValue: any; onChange: any };
  vertical?: boolean;
  centering?: string;
  name: string;
  radioButtonItem: RadioButtonItem[];
  helperText?: string;
  labelClassName?: string;
  [key: string]: any;
};

export type RadioButtonItem = {
  id: string;
  title: React.ReactNode;
  value?: string | undefined;
};
const style = {
  sizes: {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  },
  colors: {
    blue: "text-blue-600 focus:ring-blue-500",
    green: "text-green-600 focus:ring-green-500",
    red: "text-red-600 focus:ring-red-500",
    yellow: "text-yellow-500 focus:ring-yellow-400",
    indigo: "text-indigo-600 focus:ring-indigo-500",
  },
  vertical: " sm:flex sm:items-center sm:space-y-0 sm:space-x-10",
};

export const RadioButton = ({
  children,
  className,
  color = "indigo",
  size = "md",
  value,
  vertical = false,
  centering = "",
  name,
  label,
  type,
  radioButtonItem,
  helperText,
  labelClassName,
  ...props
}: RadioButtonGroupProps) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    console.log(event.target.dataset.value);
    value?.setValue(event.target.dataset.value);
  };

  const styles = {
    rounded: `rounded-full`,
    block: `flex justify-center w-full`,
    error: `border-red-300 ring-red-500 ring-1 focus:ring-red-500 focus:border-red-500`,
    errorMessage: `text-xs text-red-500 mt-2`,
    default: `text-white focus:outline-none shadow font-medium transition ease-in duration-200`,
    disabled: `opacity-60 cursor-not-allowed`,
    sizes: {
      sm: "px-6 py-1 text-sm",
      md: "px-6 py-2",
      lg: "px-6 py-3 text-lg",
    },
    colors: {
      blue: "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
      green: "border-gray-300 focus:border-green-500 focus:ring-green-500",
      red: "border-gray-300 focus:border-red-500 focus:ring-red-500",
      yellow: "border-gray-300 focus:border-yellow-500 focus:ring-yellow-500",
      indigo: "border-gray-300 focus:border-indigo-500 focus:ring-indigo-500",
    },
  };

  return (
    <div>
      <div className={`space-y-4 ${vertical ? style.vertical : ""} ${className}`}>
        <Label
          className={`flex items-center text-sm font-medium text-gray-700 ${vertical && centering !== "" ? ` basis-${centering} justify-end` : " mr-4"} ${labelClassName}`}
          id={"select"}
        >{label}{props.required && <div className="text-red-500 mx-1">*</div>}</Label>
        {radioButtonItem.map((item) => {
          const returnValue = item.value ?? item.id;
          return (
          <div key={item.id} className="flex  items-center">
            <input
              id={item.id}
              name={name}
              type="radio"
              data-value={returnValue}
              {...props}
              onChange={onChange}
              checked={value?.value === returnValue}
              className={`${style.sizes[size]} mr-1 border-gray-300 ${style.colors[color]}`}
            />
            <label
              htmlFor={item.id}
              className="ml-1 block text-sm font-medium text-gray-500"
            >
              {item.title}
            </label>
          </div>
        )})}
      </div>
      {props.error && (
        <span role="alert" className={`${styles.errorMessage} whitespace-nowrap`}>
          {helperText}
        </span>
      )}
    </div>
  );
};
